window.WOOD_STATE = {
  historyStack: [],
  cachedColorCount: 0,
  currentTextTier: "medium",
  activeTextLayer: null
};

window.els = {};

function cacheElements() {

  window.els = {

    preview:
      document.getElementById("preview"),

    addonLayer:
      document.getElementById("addonLayer"),

    textInput:
      document.getElementById("customTextInput"),

    previewText:
      document.getElementById("liveTextPreview"),

    textSizeSlider:
      document.getElementById("textSizeSlider"),

    textColorPicker:
      document.getElementById("textColorPicker"),

    addTextLayerBtn:
      document.getElementById("addTextLayer"),

    sizeSelector:
      document.getElementById("sizeSelector"),

    woodType:
      document.getElementById("woodType"),

    layerSelector:
  document.getElementById("layerSelector"),

    shapeSelector:
      document.getElementById("shapeSelector"),

    textStyle:
      document.getElementById("textStyle"),

    stainSelector:
      document.getElementById("stainSelector"),

    detailToggle:
      document.getElementById("detailToggle"),

    uploader:
      document.getElementById("imageUploader"),


      imageSizeSlider:
      document.getElementById("imageSizeSlider"),

      imageSizeContainer:
      document.getElementById("imageSizeContainer"),
      liveImage:
      document.getElementById("liveImagePreview"),

    imageWrapper:
      document.getElementById("imageWrapper"),

    rushOrder:
      document.getElementById("rushOrder"),

    baseWoodImage:
      document.getElementById("baseWoodImage"),

    saveBtn:
      document.getElementById("saveDesignBtn"),

    loadBtn:
      document.getElementById("loadDesignBtn"),

    undoBtn:
      document.getElementById("undoBtn"),

    deleteBtn:
      document.getElementById("deleteImageBtn"),

    exportBtn:
      document.getElementById("exportDesign"),

    colorPalette:
      document.getElementById("colorPalette"),

    colorInfoBox:
      document.getElementById("colorInfoBox"),

    colorCountText:
      document.getElementById("colorCountText"),

    colorPriceText:
      document.getElementById("colorPriceText"),

    colorComplexityText:
      document.getElementById("colorComplexityText"),

    scaleFill:
      document.getElementById("scaleFill"),

    totalEl:
      document.getElementById("liveTotal"),

    form:
  document.querySelector('form[action*="/cart/add"]'),

basePriceEl:
  document.getElementById("basePrice"),

woodCostEl:
  document.getElementById("woodCost"),

layerCostEl:
  document.getElementById("layerCost"),

stainCostEl:
  document.getElementById("stainCost"),

textCostEl:
  document.getElementById("textCost"),

rushCostEl:
  document.getElementById("rushCost"),

colorCostEl:
  document.getElementById("colorCost"),

detailCostEl:
  document.getElementById("detailCost"),

textStyleCostEl:
  document.getElementById("textStyleCost"),

liveSize:
  document.getElementById("liveSize"),

liveShape:
  document.getElementById("liveShape"),

liveWood:
  document.getElementById("liveWood"),

builderError:
  document.getElementById("builderError")  
  };
}

function initCustomizer() {

  cacheElements();

  window.WOODEvents?.init?.();

window.WOODPreview?.init?.();

window.WOODPricing?.init?.();

window.WOODStorage?.load?.();

window.WOODUI?.init?.();
  

console.log("Customizer initialized");
}

if (document.readyState === "loading") {

  document.addEventListener(
    "DOMContentLoaded",
    initCustomizer
  );

} else {

  initCustomizer();
}